import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}


const RightsKey = 'rights'

export function getRights() {
    return Cookies.get(RightsKey)
}

export function setRights(rights) {
    return Cookies.set(RightsKey, rights)
}

export function removeRights() {
    return Cookies.remove(RightsKey)
}
export function setStorage(key, value) {
    return Cookies.set(key, value)
}

export function getStorage(key) {
    return Cookies.get(key)
}

export function removeStorage(key) {
    return Cookies.remove(key)
}

export function clearStorage() {
    const json = Cookies.getJSON()
    for (const m in json) {
        Cookies.remove(m)
    }
    return
}
